<div class="row">
  <div class="col-12">
    @if (calculationStatusEnum === CalculationStatusEnum.Created && calculationResponse?.resultId !== undefined) {
      <div
        class="alert alert-warning"
        role="alert">
        <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Attention! Les résultats pourraient ne
      plus être à jour. </h2>
      Puisque des modifications ont été apportése aux valeurs du formulaire, il se pourrait que les résultats ne
      soient pas à jour.
      Pour vous assurez que les résultats soient bien à jour avec les nouvelles valeurs, veuillez rouler le calcul
      de nouveau.
      <br>
        <br>
          <div>
            <a href="" routerLink="../" style="margin-right: 15px;">Retour au formulaire</a>
          </div>
        </div>
      }
      @if (calculationStatusEnum === CalculationStatusEnum.Created  && calculationResponse?.resultId === undefined) {
        <div
          class="alert alert-warning"
          role="alert">
          <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Résultats indisponibles</h2>
          Afin de voir les résulats, vous devez rouler le calcul au moins une fois.
          <br>
            <br>
              <div>
                <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
                formulaire</a>
              </div>
            </div>
          }

          @if (calculationStatusEnum === CalculationStatusEnum.Error) {
            <div class="alert alert-danger" role="alert">
              <h2 class="alert-heading"><i class="fas fa-exclamation-circle"></i> Certaines erreurs se sont produites.
            Veuillez les corriger en retournant au formulaire. </h2>
            <ul>
              @for (error of calculationResponse.results?.errors; track error) {
                <li
                  style="font-size:14pt;">{{ getErrorText(error) }}
                </li>
              }
            </ul>
            <div class="mt-5">
              <a class="btn btn-sm btn-secondary" href="" routerLink="../">Retourner au formulaire</a>
            </div>
          </div>
        }

        @if (calculationStatusEnum === 'COMPLETED' && calculationResponse.results?.warnings?.length > 0) {
          <div
            class="alert alert-warning"
            role="alert">
            <h2 class="alert-heading"><i class="fas fa-exclamation-circle me-3"></i> Votre calcul s'est complété avec
          quelques avertissements </h2>
          <ul>
            @for (warning of calculationResponse.results?.warnings; track warning) {
              <li
                style="font-size:14pt;">{{ warning }}
              </li>
            }
          </ul>
          <div class="mt-5">
            <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
            formulaire</a>
          </div>
        </div>
      }

      @if (calculationStatusEnum === CalculationStatusEnum.InProgress) {
        <div class="alert alert-primary">
          <h2 class="alert-heading mt-2 mb-2"><i class="fas fa-circle-notch fa-spin me-3"></i> Calcul en cours
        d'exécution.</h2>
      </div>
    }
  </div>
</div>

@if (calculationResponse?.results !== undefined && calculationStatusEnum === CalculationStatusEnum.Completed) {
  <div
    class="results">
    <div class="row">
      <div class="col-12">
        <app-rollover-section-85-result
          [options]="options"
          [results]="results">
        </app-rollover-section-85-result>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-rollover-share-capital-result
          [options]="options"
          [results]="results">
        </app-rollover-share-capital-result>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-rollover-amount-to-declare-result
          [options]="options"
          [results]="results">
        </app-rollover-amount-to-declare-result>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h2 (click)="collapse.toggle()"
          [attr.aria-expanded]="!isSectionCollapsed"
          aria-controls="section">
          Conséquences fiscales
        </h2>
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isSectionCollapsed">
          @for (propertyTransferredResults of results.propertiesTransferred; track propertyTransferredResults; let i = $index) {
            <div class="row">
              <app-rollover-property-transferred-result
                [options]="options"
                [propertyTransferredOptions]="getPropertyTransferredOptionsFromResult(propertyTransferredResults)"
                [propertyTransferredResults]="propertyTransferredResults"
                [results]="results"
                [selectedBadge]="selectedBadge">
              </app-rollover-property-transferred-result>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
